import React, { useContext, useMemo, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { TableContext } from '../../index';
import { useTranslation } from 'react-i18next';

export const ResetFilterChip = () => {
  const { t } = useTranslation();
  const { filters, setFilters } = useContext(TableContext);

  const defaultValues = useMemo(
    () => ({
      ...filters,
      gender: [],
      startAge: 0,
      endAge: 130,
      risk: [],
      hasActiveAlert: false,
      hasNoActiveAlerts: false,
      condition: [],
      careTeamIds: [],
      activeRequestGroupPlanDefinitionIds: null,
      completedRequestGroupPlanDefinitionIds: null,
      hasNoRequestGroups: undefined,
      lastActivity: undefined,
      noActivity: undefined,
      patientGroupIds: [],
    }),
    [filters]
  );

  return (
    <Button
      variant="text"
      color="error"
      onClick={() => setFilters(defaultValues)}
    >
      {t('Clear filter')}
    </Button>
  );
};
